<svelte:head>
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css">
  <link rel="stylesheet" href="https://unpkg.com/leaflet@1.6.0/dist/leaflet.css"
   integrity="sha512-xwE/Az9zrjBIphAcBb3F6JVqxf46+CDLwfLMHloNu6KEQCAWi6HcDUbeOfBIptF7tcCzusKFjFw2yuvEpDL9wQ=="
   crossorigin=""/>
   <link rel="stylesheet" href="https://unpkg.com/leaflet-geosearch@3.0.0/dist/geosearch.css"/>

   <title>Seattle Live Cameras</title>

   <link
   	rel="stylesheet"
   	href="https://cdn.jsdelivr.net/npm/bootswatch@5.1.0/dist/darkly/bootstrap.min.css"
	/>
</svelte:head>

<script>
	import { onMount } from 'svelte';
	import { Container, Form, Input, Tooltip, Badge } from 'sveltestrap';
	import Fa from 'svelte-fa';
	import {faMapLocation, faVideoSlash, faPlay, faWarning} from '@fortawesome/free-solid-svg-icons';
	import L from 'leaflet';

    import "leaflet.markercluster/dist/leaflet.markercluster.js";
    import "leaflet.markercluster/dist/MarkerCluster.css";
    import "leaflet.markercluster/dist/MarkerCluster.Default.css";

	import Hls from 'hls.js';

const datasetRequestUrl = "/live/data/dataset.geojson";
	const sdotMapApiUrl = "/live/data/sdot.json";
	const bellevueCameraApiUrl = "/live/data/bellevue.geojson";
	const wsdotKingCountyCameraApiUrl = "/live/data/wsdot-cameras.json";
	const customCameras = [
  {
    "id": "custom-squalicum-harbor",
    "location": "Squalicum Harbor",
    "url": "https://rtsp.run/embed.html?streamUrl=ODQ4MDQ0MWM5ZjU1NTk1ZWUyZjc1Zjk2ZDM4ZjFmYzA6ZXlKMklqb3lMQ0pqZENJNkluRnhXVGczYzI1a05HcHRhSFJ0TmpOdFRpdFVLMFl6ZFhCbGVVOXZVVEp3TlhVMmRHcHVUWG8yVEZKTFNtUTRWMEVyYWxsTGFVSTRVMHhxUVVjMmFuVWlMQ0p0WVdNaU9pSlVkU3QxYUd0S1ZYSjRkbWxrYjAxS2NERndlRGs0UWxoVGMxb3JjMkpNVmxGTGRuTlJjWEZOY0ZwalBTSjk=&lang=en",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 48.7578756936008,
      "lon": -122.49717822415457
    }
  },
  {
    "id": "custom-bridge-way-ne",
    "location": "Bridge Way NE",
    "url": "https://rtsp.run/embed.html?streamUrl=YTUyZDRiOTA3MzQxNTAxNzU3NDFkOWY2NGY4ZGZkYTE6ZXlKMklqb3lMQ0pqZENJNkltcG1OVk0xVFV4MWEyWTJZM1V6ZFdrNVdFcFVTbXRGVlhjd1pIVm9lVFZTT1c1M1EzZHZkVlIyT1VsWVNFVXZjVlI2Tm5wb00yZHlWRE12Y2pGNGFtVWlMQ0p0WVdNaU9pSnBUM3BVT0dFd1JXeHZLMHA2U25ob2JsUjRkazloUTNCWFpYQjNjMFV2ZDNObFpVVlhhR2hWTnpCalBTSjk=&lang=en",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.84990928932478,
      "lon": -122.61276163721107
    }
  },
  {
    "id": "custom-circlek-shell-station",
    "location": "CircleK / Shell Station",
    "url": "https://rtsp.run/embed.html?streamUrl=ZGFkOWRmNTQyZDZjN2VjYWNkNzFlYTliNzhjNjg0MzA6ZXlKMklqb3lMQ0pqZENJNklsZFBkbTgxWWxoclkyMTJOSGMzU2sxcmFIcGtSMUZUUWl0bFNWWnhkelpVZHpGSllrWkRZVU5vYmpSSGNVRjRVekJIVFVWbk9VOWhVRWRPYkd4bmNVUXdiamRUYTFGRE0xTjJLMDFxUzFkWVNXY3dkV2hOVEc5V01ubEdNRlF3ZGpndk5tcEVSWHA2U2tsUlBTSXNJbTFoWXlJNklrUjJia05TYkhCMmFISTJhVzlJVDNSVlJHNTNhWE5FWWpWdFJVd3dSMkV6VVU1VlpscHFhVk5RVjNjOUluMD0=&lang=en",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.59466251265464,
      "lon": -122.30992600016077
    }
  },
  {
    "id": "custom-seattle-aquarium-otter-feed",
    "location": "Seattle Aquarium Sea Otter Feed",
    "url": "https://www.youtube.com/watch?v=NqOmHpwMUxs",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 47.6076095,
      "lon": -122.343617
    }
  },
  {
    "id": "custom-pike-place-fish-camera",
    "location": "Pike Place Fish Camera",
    "url": "https://video.nest.com/embedded/live/vWNPfeNo0j?autoplay=1",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.60863437420682,
      "lon": -122.34068825920423
    }
  },
  {
    "id": "custom-space-needle-panocam",
    "location": "Space Needle Panocam",
    "url": "https://spaceneedle.roundshot.com/#/",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.6205063,
      "lon": -122.3492774
    }
  },
  {
    "id": "custom-earthcam-space-needle",
    "location": "EarthCam Space Needle Cam",
    "url": "https://www.earthcam.com/usa/washington/seattle/?cam=seattlespaceneedle&embed",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.6205131,
      "lon": -122.34930359883187
    }
  },
  {
    "id": "custom-1201-third-peregrine-falcon",
    "location": "1201 Third Ave Peregrine Falcon Cam",
    "url": "https://player.castr.com/live_344e7a90c8ce11ed925f2d6300baff8b?initialQuality=480p",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.6071707,
      "lon": -122.3360996
    }
  },
  {
    "id": "custom-uw-red-square-cam",
    "location": "UW Red Square Cam",
    "url": "https://www.youtube.com/watch?v=blcKdwh1mqY",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 47.655989894477145,
      "lon": -122.30949454376858
    }
  },
  {
    "id": "custom-uw-continuum-college-cam",
    "location": "UW Continuum College",
    "url": "https://www.youtube.com/watch?v=4cgSE12k9Sc",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 47.66041597834954,
      "lon": -122.31692300493431
    }
  },
  {
    "id": "custom-uw-lake-washington-cam",
    "location": "UW Lake Washington Cam",
    "url": "https://www.youtube.com/watch?v=fhKwZEtdgVI",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 47.65150346387281,
      "lon": -122.29241033962919
    }
  },
  {
    "id": "custom-uw-husky-stadium-cam",
    "location": "UW Husky Stadium Cam",
    "url": "https://wsrv.nl/?url=128.208.103.23/oneshotimage.jpg",
    "source": "CUSTOM",
    "streamType": "image",
    "refreshMs": 60000,
    "coordinates": {
      "lat": 47.6503736,
      "lon": -122.301976
    }
  },
  {
    "id": "custom-northgate-pedestrian-bridge",
    "location": "Northgate Pedestrian Bridge",
    "coordinates": {
      "lat": 47.70068196510462,
      "lon": -122.33343147357498
    },
    "url": "https://wsrv.nl/?url=168.156.125.101/jpg/image.jpg",
    "source": "CUSTOM",
    "streamType": "image",
    "refreshMs": 60000
  },
  {
    "id": "custom-chehalis-centralia-airport",
    "location": "Chehalis-Centralia Airport",
    "coordinates": {
      "lat": 46.67291362794443,
      "lon": -122.98480763657098
    },
    "url": "https://wsrv.nl/?url=23.25.129.90:8000/jpg/image.jpg",
    "source": "CUSTOM",
    "streamType": "image",
    "refreshMs": 60000
  },
  {
    "id": "custom-fair-harbor-marina",
    "location": "Fair Harbor Marina",
    "coordinates": {
      "lat": 47.5459,
      "lon": -122.5889
    },
    "url": "/live/feed/custom-fair-harbor-marina.mjpeg",
    "source": "CUSTOM",
    "streamType": "mjpeg",
    "refreshMs": 0
  },
  {
    "id": "custom-seattle-from-clyde-hill",
    "location": "Seattle from Clyde Hill",
    "coordinates": {
      "lat": 47.6154,
      "lon": -122.2103
    },
    "url": "https://wsrv.nl/?url=50.197.88.29/jpg/image.jpg",
    "source": "CUSTOM",
    "streamType": "image",
    "refreshMs": 60000
  },
  {
    "id": "custom-seattle-from-clyde-hill-2",
    "location": "Seattle from Clyde Hill 2",
    "coordinates": {
      "lat": 47.6154,
      "lon": -122.2103
    },
    "url": "https://wsrv.nl/?url=50.197.88.14/jpg/image.jpg",
    "source": "CUSTOM",
    "streamType": "image",
    "refreshMs": 60000
  },
  {
    "id": "custom-whatcom-community-college",
    "location": "Whatcom Community College",
    "coordinates": {
      "lat": 47.6727,
      "lon": -122.1873
    },
    "url": "https://wsrv.nl/?url=50.251.230.5/jpg/image.jpg",
    "source": "CUSTOM",
    "streamType": "image",
    "refreshMs": 60000
  },
  {
    "id": "custom-sunderland-plaza-lewis-clark-law",
    "location": "Sunderland Plaza entrance at Lewis & Clark Law School",
    "coordinates": {
      "lat": 47.2389,
      "lon": -123.2061
    },
    "url": "https://wsrv.nl/?url=134.39.37.20/jpg/image.jpg",
    "source": "CUSTOM",
    "streamType": "image",
    "refreshMs": 60000
  },
  {
    "id": "custom-stewart-lodge",
    "location": "Stewart Lodge",
    "coordinates": {
      "lat": 47.19638665700975,
      "lon": -120.95504090330218
    },
    "url": "https://wsrv.nl/?url=204.106.237.68:88/jpg/1/image.jpg",
    "source": "CUSTOM",
    "streamType": "image",
    "refreshMs": 60000
  },
  {
    "id": "custom-mountain-lake",
    "location": "Mountain Lake",
    "coordinates": {
      "lat": 48.65486070433682,
      "lon": -122.81897505090828
    },
    "url": "https://wsrv.nl/?url=207.32.161.96/jpg/image.jpg",
    "source": "CUSTOM",
    "streamType": "image",
    "refreshMs": 60000
  },
  {
    "id": "custom-sr-3-and-christopherson",
    "location": "SR 3 and Christopherson",
    "coordinates": {
      "lat": 47.525585463691684,
      "lon": -122.70430336545039
    },
    "url": "https://wsrv.nl/?url=65.102.172.35/jpg/image.jpg",
    "source": "CUSTOM",
    "streamType": "image",
    "refreshMs": 60000
  },
  {
    "id": "custom-uw-cherry-blossom-cam",
    "location": "UW Cherry Blossom Cam (facing west from Miller Hall)",
    "url": "https://www.youtube.com/watch?v=JfQTgK0k8XE",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 47.65735315141479,
      "lon": -122.30668086689441
    }
  },
  {
    "id": "custom-virtualrailfan-foster-white-gallery-ptz",
    "location": "VirtualRailfan Foster White Gallery Train Camera (PTZ)",
    "url": "https://www.youtube.com/watch?v=pHqTDmH7H7c",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 47.600228405756006,
      "lon": -122.32954372814451
    }
  },
  {
    "id": "custom-virtualrailfan-foster-white-gallery-south",
    "location": "VirtualRailfan Foster White Gallery Train Camera (South)",
    "url": "https://www.youtube.com/live/K7ZUj82iPkU",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 47.600228405756006,
      "lon": -122.32954372814451
    }
  },
  {
    "id": "custom-abc-legal-services-roof-camera",
    "location": "ABC Legal Services - Roof Camera",
    "url": "https://www.youtube.com/watch?v=oM5m6sFQxzo",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 47.61662518489241,
      "lon": -122.33271682369246
    }
  },
  {
    "id": "custom-bellingham-bay-zuanich-point",
    "location": "Bellingham Bay from Zuanich Point Park",
    "url": "https://www.youtube.com/watch?v=6j0aasCRk_k",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 48.754332028763,
      "lon": -122.50146925449
    }
  },
  {
    "id": "custom-port-everett-boat-launch",
    "location": "Port of Everett Boat Launch Camera",
    "url": "https://www.youtube.com/watch?v=BsfcSCJZRFM",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 47.9953751,
      "lon": -122.2164058
    }
  },
  {
    "id": "custom-summit-central-base-area",
    "location": "The Summit at Snoqualmie - Summit Central Base Area",
    "url": "https://www.youtube.com/watch?v=GcIAQ5iD35o",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 47.4106,
      "lon": -121.4139
    }
  },
  {
    "id": "custom-summit-west-base-area",
    "location": "The Summit at Snoqualmie - Summit West Base Area",
    "url": "https://www.youtube.com/watch?v=vhO8nNqg9iw",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 47.4219,
      "lon": -121.4204
    }
  },
  {
    "id": "custom-summit-silver-fir-base-area",
    "location": "The Summit at Snoqualmie - Silver Fir Base Area",
    "url": "https://www.youtube.com/watch?v=H7HwsNLqVC8",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 47.4008,
      "lon": -121.4073
    }
  },
  {
    "id": "custom-summit-central-top",
    "location": "The Summit at Snoqualmie - Summit Central Top",
    "url": "https://www.youtube.com/watch?v=w4Sno8NIjmU",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 47.407,
      "lon": -121.4072
    }
  },
  {
    "id": "custom-alpental-base-area",
    "location": "The Summit at Snoqualmie - Alpental Base Area",
    "url": "https://www.youtube.com/watch?v=8wk81COX2cg",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 47.445,
      "lon": -121.4244
    }
  },
  {
    "id": "custom-alpental-mid-mountain",
    "location": "The Summit at Snoqualmie - Alpental Mid-Mountain",
    "url": "https://www.youtube.com/watch?v=c_XLrUYV8tk",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 47.4456,
      "lon": -121.4149
    }
  },
  {
    "id": "custom-washington-island-ferry-dock-3",
    "location": "Washington Island Ferry Dock Camera #3",
    "url": "https://www.youtube.com/watch?v=UmiLYeh8-r8",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 45.4008113,
      "lon": -86.8585284
    }
  },
  {
    "id": "custom-northport-pier-ferry-dock-1",
    "location": "Northport Pier Ferry Dock Camera #1",
    "url": "https://www.youtube.com/watch?v=Zot8ShPuuKg",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 45.2904944,
      "lon": -86.9774444
    }
  },
  {
    "id": "custom-northport-pier-ferry-dock-2",
    "location": "Northport Pier Ferry Dock Camera #2",
    "url": "https://www.youtube.com/watch?v=TXQcLxneF5A",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 45.29056,
      "lon": -86.9775
    }
  },
  {
    "id": "custom-gills-rock-live-camera",
    "location": "Gills Rock Live Camera",
    "url": "https://www.youtube.com/watch?v=aznpm4poXp4",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 45.2902247,
      "lon": -87.0219581
    }
  },
  {
    "id": "custom-cowlitz-river-cam-1",
    "location": "Cowlitz River Cam 1",
    "url": "https://www.youtube.com/watch?v=YRq4KmrYvyY",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 46.4995,
      "lon": -122.3723
    }
  },
  {
    "id": "custom-cowlitz-river-cam-2",
    "location": "Cowlitz River Live Cam 2",
    "url": "https://www.youtube.com/watch?v=4a35Qsbf3ow",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 46.4996,
      "lon": -122.3724
    }
  },
  {
    "id": "custom-leavenworth-kris-kringl",
    "location": "Leavenworth Kris Kringl Webcam",
    "url": "https://www.youtube.com/watch?v=TmtVbezZaqg",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 47.5957964,
      "lon": -120.6607168
    }
  },
  {
    "id": "custom-auburn-airport-kaun",
    "location": "Auburn Airport Camera (KAUN)",
    "url": "https://www.youtube.com/watch?v=t0J6D3XAVh8",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 38.9541225,
      "lon": -121.082132
    }
  },
  {
    "id": "custom-terminal-5-south-gate-camera",
    "location": "Terminal 5 South Gate Camera",
    "url": "https://terminalcamera.tideworks.com/T5Sgate.jpg",
    "source": "CUSTOM",
    "streamType": "image",
    "coordinates": {
      "lat": 47.57435001765367,
      "lon": -122.36696704859351
    }
  },
  {
    "id": "custom-spu-bertona-and-fifth",
    "location": "SPU - Bertona and Fifth",
    "url": "https://spu.edu/webcam/pics/bertona.jpg?1781419461746",
    "source": "CUSTOM",
    "streamType": "image",
    "coordinates": {
      "lat": 47.65034306822061,
      "lon": -122.36357310439772
    }
  },
  {
    "id": "custom-spu-tiffany-loop-east",
    "location": "SPU - Tiffany Loop East",
    "url": "https://spu.edu/webcam/pics/Loop-E.jpg?1781419522393",
    "source": "CUSTOM",
    "streamType": "image",
    "coordinates": {
      "lat": 47.64958330810114,
      "lon": -122.36169413660744
    }
  },
  {
    "id": "custom-spu-tiffany-loop-north",
    "location": "SPU - Tiffany Loop North",
    "url": "https://spu.edu/webcam/pics/Loop-N.jpg?1781419528681",
    "source": "CUSTOM",
    "streamType": "image",
    "coordinates": {
      "lat": 47.64958330810114,
      "lon": -122.36169413660744
    }
  },
  {
    "id": "custom-spu-corner-market-place",
    "location": "SPU - Corner Market Place",
    "url": "https://spu.edu/webcam/pics/CStore-S.jpg?1781419539409",
    "source": "CUSTOM",
    "streamType": "image",
    "coordinates": {
      "lat": 47.64988959181154,
      "lon": -122.36446568662453
    }
  },
  {
    "id": "custom-spu-demaray-hall-ne",
    "location": "SPU - Demaray Hall NE",
    "url": "https://spu.edu/webcam/pics/Residence-Hall-Construction-N.jpg",
    "source": "CUSTOM",
    "streamType": "image",
    "coordinates": {
      "lat": 47.65035336085091,
      "lon": -122.3641338681362
    }
  },
  {
    "id": "custom-spu-martin-square-south",
    "location": "SPU - Martin Square South",
    "url": "https://spu.edu/webcam/pics/MartinSq-S.jpg?1781419704233",
    "source": "CUSTOM",
    "streamType": "image",
    "coordinates": {
      "lat": 47.649419582168406,
      "lon": -122.36394882208744
    }
  },
  {
    "id": "custom-spu-martin-square-north",
    "location": "SPU - Martin Square North",
    "url": "https://spu.edu/webcam/pics/MartinSq.jpg?1781419737661",
    "source": "CUSTOM",
    "streamType": "image",
    "coordinates": {
      "lat": 47.649419582168406,
      "lon": -122.36394882208744
    }
  },
  {
    "id": "custom-boeing-field-kbfi-northwest",
    "location": "Boeing Field (KBFI) - Northwest",
    "url": "https://www.wasar.org/wp-content/themes/wasar/kbfi/north.php",
    "source": "CUSTOM",
    "streamType": "image",
    "coordinates": {
      "lat": 47.53785312168197,
      "lon": -122.30604418413466
    }
  },
  {
    "id": "custom-boeing-field-kbfi-southwest",
    "location": "Boeing Field (KBFI) - Southwest",
    "url": "https://www.wasar.org/wp-content/themes/wasar/kbfi/south.php",
    "source": "CUSTOM",
    "streamType": "image",
    "coordinates": {
      "lat": 47.53785312168197,
      "lon": -122.30604418413466
    }
  },
  {
    "id": "custom-anthonys-pier-66",
    "location": "Anthony's Pier 66 Live Camera",
    "url": "https://g1.ipcamlive.com/player/player.php?alias=09pier66",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.61090802355422,
      "lon": -122.3481641951859
    }
  },
  {
    "id": "custom-mount-rainier-paradise-upper",
    "location": "Mount Rainier National Park - Paradise Upper Parking Area",
    "url": "https://www.nps.gov/webcams-mora/east.jpg",
    "source": "CUSTOM",
    "streamType": "image",
    "coordinates": {
      "lat": 46.785845,
      "lon": -121.736363
    }
  },
  {
    "id": "custom-fox13-lake-union",
    "location": "Fox 13 Seattle Lake Union Live Camera",
    "url": "https://api.wetmet.net/widgets/stream/frame.php?uid=bead63f334e9e378293dd668bd65a100",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.63528609472992,
      "lon": -122.33874133629037
    }
  },
  {
    "id": "custom-fox13-seatac-airport",
    "location": "Fox 13 Seattle-Tacoma International Airport Live Camera",
    "url": "https://api.wetmet.net/widgets/stream/frame.php?uid=5ebc979229971af80b7428be11922412",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.4475673,
      "lon": -122.3080159
    }
  },
  {
    "id": "custom-fox10-lumen-field",
    "location": "Fox 10 Lumen Field",
    "url": "https://api.wetmet.net/widgets/stream/frame.php?uid=7683690d70237b0f4cce926f266ac15d",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.597279429118856,
      "lon": -122.3312179922337
    }
  },
  {
    "id": "custom-dog-yard-bar",
    "location": "Dog Yard Bar",
    "url": "https://g1.ipcamlive.com/player/player.php?alias=60df8453ab750",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.66389958200274,
      "lon": -122.37790393198391
    }
  },
  {
    "id": "custom-downtown-dog-lounge-ballard-heart-of-house",
    "location": "Downtown Dog Lounge Ballard - Heart of the House",
    "url": "https://g1.ipcamlive.com/player/player.php?alias=5c3263db7e03e&autoplay=1",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.66235785612967,
      "lon": -122.3671826848855
    }
  },
  {
    "id": "custom-downtown-dog-lounge-ballard-outdoor-1",
    "location": "Downtown Dog Lounge Ballard - Outdoor 1",
    "url": "https://g1.ipcamlive.com/player/player.php?alias=5c32596b65526&autoplay=1",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.66235785612967,
      "lon": -122.3671826848855
    }
  },
  {
    "id": "custom-downtown-dog-lounge-ballard-outdoor-2",
    "location": "Downtown Dog Lounge Ballard - Outdoor 2",
    "url": "https://g1.ipcamlive.com/player/player.php?alias=5c32636731455&autoplay=1",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.66235785612967,
      "lon": -122.3671826848855
    }
  },
  {
    "id": "custom-downtown-dog-lounge-ballard-senior-center",
    "location": "Downtown Dog Lounge Ballard - Senior Center",
    "url": "https://g1.ipcamlive.com/player/player.php?alias=5c325bcce7086&autoplay=1",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.66235785612967,
      "lon": -122.3671826848855
    }
  },
  {
    "id": "custom-downtown-dog-lounge-ballard-west-park-1",
    "location": "Downtown Dog Lounge Ballard - West Park 1",
    "url": "https://g1.ipcamlive.com/player/player.php?alias=5c32618141523&autoplay=1",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.66235785612967,
      "lon": -122.3671826848855
    }
  },
  {
    "id": "custom-downtown-dog-lounge-ballard-west-park-2",
    "location": "Downtown Dog Lounge Ballard - West Park 2",
    "url": "https://g1.ipcamlive.com/player/player.php?alias=5c3265e523e02&autoplay=1",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.66235785612967,
      "lon": -122.3671826848855
    }
  },
  {
    "id": "custom-downtown-dog-lounge-slu-east-park",
    "location": "Downtown Dog Lounge South Lake Union - East Park",
    "url": "https://g1.ipcamlive.com/player/player.php?alias=57d79729b11b0&autoplay=1",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.6240564,
      "lon": -122.3364646
    }
  },
  {
    "id": "custom-downtown-dog-lounge-slu-west-park",
    "location": "Downtown Dog Lounge South Lake Union - West Park",
    "url": "https://g1.ipcamlive.com/player/player.php?alias=57d796dc274ef&autoplay=1",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.6240564,
      "lon": -122.3364646
    }
  },
  {
    "id": "custom-downtown-dog-lounge-slu-senior-center",
    "location": "Downtown Dog Lounge South Lake Union - Senior Center",
    "url": "https://g1.ipcamlive.com/player/player.php?alias=591297926d739&autoplay=1",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.6240564,
      "lon": -122.3364646
    }
  },
  {
    "id": "custom-downtown-dog-lounge-slu-puppy-park-east",
    "location": "Downtown Dog Lounge South Lake Union - Puppy Park East",
    "url": "https://g1.ipcamlive.com/player/player.php?alias=57d797d7d4a98&autoplay=1",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.6240564,
      "lon": -122.3364646
    }
  },
  {
    "id": "custom-downtown-dog-lounge-slu-puppy-park-west",
    "location": "Downtown Dog Lounge South Lake Union - Puppy Park West",
    "url": "https://g1.ipcamlive.com/player/player.php?alias=57d7977d54a8b&autoplay=1",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.6240564,
      "lon": -122.3364646
    }
  },
  {
    "id": "custom-downtown-dog-lounge-slu-premium-luxury-suites-south",
    "location": "Downtown Dog Lounge South Lake Union - Premium Luxury Suites South",
    "url": "https://g1.ipcamlive.com/player/player.php?alias=57d798335d414&autoplay=1",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.6240564,
      "lon": -122.3364646
    }
  },
  {
    "id": "custom-downtown-dog-lounge-slu-premium-luxury-suites-north",
    "location": "Downtown Dog Lounge South Lake Union - Premium Luxury Suites North",
    "url": "https://g1.ipcamlive.com/player/player.php?alias=57d72abdbcbdb&autoplay=1",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.6240564,
      "lon": -122.3364646
    }
  },
  {
    "id": "custom-downtown-dog-lounge-slu-central-park",
    "location": "Downtown Dog Lounge South Lake Union - Central Park",
    "url": "https://g1.ipcamlive.com/player/player.php?alias=5aec9329bc357&autoplay=1",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.6240564,
      "lon": -122.3364646
    }
  },
  {
    "id": "custom-dicks-drive-in-holman-road-patio",
    "location": "Dick's Drive-In Holman Road - Patio",
    "url": "https://ddir.com/locations/holman-road",
    "source": "CUSTOM",
    "streamType": "external",
    "coordinates": {
      "lat": 47.696487210240555,
      "lon": -122.3716798072135
    }
  },
  {
    "id": "custom-dicks-drive-in-broadway-patio",
    "location": "Dick's Drive-In Broadway - Patio",
    "url": "https://ddir.com/locations/broadway",
    "source": "CUSTOM",
    "streamType": "external",
    "coordinates": {
      "lat": 47.6193196,
      "lon": -122.3211927
    }
  },
  {
    "id": "custom-dicks-drive-in-wallingford-45th-st",
    "location": "Dick's Drive-In Wallingford - 45th St",
    "url": "https://ddir.com/locations/wallingford",
    "source": "CUSTOM",
    "streamType": "external",
    "coordinates": {
      "lat": 47.66114075097424,
      "lon": -122.32770437700086
    }
  },
  {
    "id": "custom-dicks-drive-in-lake-city-30th-ave",
    "location": "Dick's Drive-In Lake City - 30th Ave",
    "url": "https://ddir.com/locations/lake-city",
    "source": "CUSTOM",
    "streamType": "external",
    "coordinates": {
      "lat": 47.7182053,
      "lon": -122.2968988
    }
  },
  {
    "id": "custom-salmon-bay-marine-center-dock-cam-1",
    "location": "Salmon Bay Marine Center - Dock Cam 1",
    "url": "https://s134.ipcamlive.com/streams/86vhl3lx07emez18a/stream.m3u8",
    "source": "CUSTOM",
    "streamType": "hls",
    "coordinates": {
      "lat": 47.66133168126127,
      "lon": -122.38644793325713
    }
  },
  {
    "id": "custom-salmon-bay-marine-center-dock-cam-2",
    "location": "Salmon Bay Marine Center - Dock Cam 2",
    "url": "https://s134.ipcamlive.com/streams/86rlksfctxxiha5ta/stream.m3u8",
    "source": "CUSTOM",
    "streamType": "hls",
    "coordinates": {
      "lat": 47.66133168126127,
      "lon": -122.38644793325713
    }
  },
  {
    "id": "custom-salmon-bay-marine-center-dock-cam-3",
    "location": "Salmon Bay Marine Center - Dock Cam 3",
    "url": "https://s65.ipcamlive.com/streams/41qdqpgrouuakkijc/stream.m3u8",
    "source": "CUSTOM",
    "streamType": "hls",
    "coordinates": {
      "lat": 47.66133168126127,
      "lon": -122.38644793325713
    }
  },
  {
    "id": "custom-salmon-bay-marine-center-dock-cam-4",
    "location": "Salmon Bay Marine Center - Dock Cam 4",
    "url": "https://s81.ipcamlive.com/streams/518vmwze6dcnmitv1/stream.m3u8",
    "source": "CUSTOM",
    "streamType": "hls",
    "coordinates": {
      "lat": 47.66133168126127,
      "lon": -122.38644793325713
    }
  },
  {
    "id": "custom-salmon-bay-marine-center-dock-cam-5",
    "location": "Salmon Bay Marine Center - Dock Cam 5",
    "url": "https://s73.ipcamlive.com/streams/49097vrxoabt6lgkz/stream.m3u8",
    "source": "CUSTOM",
    "streamType": "hls",
    "coordinates": {
      "lat": 47.66133168126127,
      "lon": -122.38644793325713
    }
  },
  {
    "id": "custom-salmon-bay-marine-center-dock-cam-6",
    "location": "Salmon Bay Marine Center - Dock Cam 6",
    "url": "https://s109.ipcamlive.com/streams/6dcqjyl06zfab1sl4/stream.m3u8",
    "source": "CUSTOM",
    "streamType": "hls",
    "coordinates": {
      "lat": 47.66133168126127,
      "lon": -122.38644793325713
    }
  },
  {
    "id": "custom-salmon-bay-marine-center-dock-cam-7",
    "location": "Salmon Bay Marine Center - Dock Cam 7",
    "url": "https://s108.ipcamlive.com/streams/6citjhufs94dbqrpa/stream.m3u8",
    "source": "CUSTOM",
    "streamType": "hls",
    "coordinates": {
      "lat": 47.66133168126127,
      "lon": -122.38644793325713
    }
  },
  {
    "id": "custom-salmon-bay-marine-center-dock-cam-8",
    "location": "Salmon Bay Marine Center - Dock Cam 8",
    "url": "https://s109.ipcamlive.com/streams/6dk1iuwv9cgfuohyw/stream.m3u8",
    "source": "CUSTOM",
    "streamType": "hls",
    "coordinates": {
      "lat": 47.66133168126127,
      "lon": -122.38644793325713
    }
  },
  {
    "id": "custom-lwrc-watercam",
    "location": "LWRC Watercam",
    "url": "https://open.ivideon.com/embed/v2/?server=200-YV6knPliOPswemRS31OP0Q&camera=0&width=&height=&lang=en",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.648268826131535,
      "lon": -122.34668693816512
    }
  },
  {
    "id": "custom-sail-sand-point-lake-washington",
    "location": "Sail Sand Point - Lake Washington",
    "url": "https://assets2.webcam.io/w/90lQN9/latest.jpg",
    "source": "CUSTOM",
    "streamType": "image",
    "coordinates": {
      "lat": 47.6888216,
      "lon": -122.2648722
    }
  },
  {
    "id": "custom-shorecrest-high-school",
    "location": "Shorecrest High School",
    "url": "https://images.webcamgalore.com/7808-current-webcam-Seattle-Washington.jpg",
    "source": "CUSTOM",
    "streamType": "image",
    "coordinates": {
      "lat": 47.74112719089785,
      "lon": -122.3042172344004
    }
  },
  {
    "id": "custom-alki-beach",
    "location": "Alki Beach",
    "url": "https://www.alkiweather.com/masked-alkibeachcam.jpg?v=1781422561",
    "source": "CUSTOM",
    "streamType": "image",
    "coordinates": {
      "lat": 47.58119718524687,
      "lon": -122.40638484804772
    }
  },
  {
    "id": "custom-komo-columbia-cam",
    "location": "KOMO News Columbia Cam",
    "url": "https://komonews.com/resources/ftptransfer/komo/maps/ColumbiaCam.jpg",
    "source": "CUSTOM",
    "streamType": "image",
    "coordinates": {
      "lat": 47.5977639,
      "lon": -122.3314056
    }
  },
  {
    "id": "custom-ballard-elks-shilshole-bay",
    "location": "Ballard Elks Paddle Club Shilshole Bay Camera",
    "url": "https://www.youtube.com/watch?v=JVTvtCZcSWk",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 47.67511231440327,
      "lon": -122.40815518560753
    }
  },
  {
    "id": "custom-seattle-ferry-terminal-main-holding",
    "location": "Seattle Ferry Terminal Main Vehicle Holding",
    "url": "https://images.wsdot.wa.gov/wsf/colman/seattlemain.jpg?1781415068082",
    "source": "CUSTOM",
    "streamType": "image",
    "coordinates": {
      "lat": 47.60219761064497,
      "lon": -122.33765958958519
    }
  },
  {
    "id": "custom-columbia-tower-lake-union",
    "location": "Columbia Tower Cam",
    "url": "https://cdn.tegna-media.com/king/weather/columbia.jpg?nonce=123",
    "source": "CUSTOM",
    "streamType": "image",
    "coordinates": {
      "lat": 47.60437163229564,
      "lon": -122.33048844187036
    }
  },
  {
    "id": "custom-queen-anne-seattle-city-cam",
    "location": "Queen Anne Seattle City Cam",
    "url": "https://cdn.tegna-media.com/king/weather/queenanne.jpg",
    "source": "CUSTOM",
    "streamType": "image",
    "coordinates": {
      "lat": 47.63213611111111,
      "lon": -122.35395833333332
    }
  },
  {
    "id": "custom-king-5-roof-cam-t-mobile-park",
    "location": "King 5 Roof Cam T-Mobile Park",
    "url": "https://cdn.tegna-media.com/king/weather/roofcam2.jpg",
    "source": "CUSTOM",
    "streamType": "image",
    "coordinates": {
      "lat": 47.59006388888889,
      "lon": -122.33445277777778
    }
  },
  {
    "id": "custom-king-5-roof-cam-coast-guard-pier",
    "location": "King 5 Roof Cam Coast Guard Pier",
    "url": "https://cdn.tegna-media.com/king/weather/roofcam1.jpg",
    "source": "CUSTOM",
    "streamType": "image",
    "coordinates": {
      "lat": 47.59026372397202,
      "lon": -122.33789953119543
    }
  },
  {
    "id": "custom-king-5-seatac-camera",
    "location": "King 5 Seatac Camera",
    "url": "https://cdn.tegna-media.com/king/weather/seatac.jpg",
    "source": "CUSTOM",
    "streamType": "image",
    "coordinates": {
      "lat": 47.4476297868125,
      "lon": -122.29703933099468
    }
  },
  {
    "id": "custom-pur-laundry-bremerton",
    "location": "PUR Laundry Bremerton",
    "url": "https://g1.ipcamlive.com/player/player.php?alias=purbremerton&autoplay=1",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.5719997,
      "lon": -122.6584634
    }
  },
  {
    "id": "custom-pur-laundry-spokane-valley",
    "location": "PUR Laundry Spokane Valley",
    "url": "https://g1.ipcamlive.com/player/player.php?alias=6165f4d349dc2&autoplay=1&disableframecapture=1",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.65698,
      "lon": -117.2301587
    }
  },
  {
    "id": "custom-pur-laundry-spokane",
    "location": "PUR Laundry Spokane",
    "url": "https://g1.ipcamlive.com/player/player.php?alias=6394298d41a29&autoplay=1&mute=1",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.6933638,
      "lon": -117.4109613
    }
  },
  {
    "id": "custom-seattle-capitol-hill-webcam",
    "location": "Seattle Capitol Hill Webcam",
    "url": "https://api.wetmet.net/widgets/stream/frame.php?uid=53e36866a29d89664d6dc5aafe4fd8b8",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.6164554,
      "lon": -122.3411944
    }
  },
  {
    "id": "custom-clean-planet-car-wash-woodinville",
    "location": "Clean Planet Car Wash Webcam in Woodinville",
    "url": "https://g1.ipcamlive.com/player/player.php?alias=5c81ad656b5eb&autoplay=1",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.7667132,
      "lon": -122.1483914
    }
  },
  {
    "id": "custom-lynden-lube-live-webcam",
    "location": "Lynden Lube Live Webcam",
    "url": "https://g1.ipcamlive.com/player/player.php?alias=67465bdfc7213&autoplay=1",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 48.9383886,
      "lon": -122.485525
    }
  },
  {
    "id": "custom-olympia-lacey-centennial-station-railcam",
    "location": "Olympia-Lacey Centennial Station Railcam",
    "url": "https://www.youtube.com/watch?v=PftkGaoFl_0",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 46.9913495,
      "lon": -122.7939369
    }
  },
  {
    "id": "custom-downtown-shelton-4th-railroad",
    "location": "Downtown Shelton - 4th & Railroad",
    "url": "https://www.youtube.com/watch?v=1hsxaZcjANM",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 47.213166,
      "lon": -123.103526
    }
  },
  {
    "id": "custom-leavenworth-adventure-park",
    "location": "Leavenworth Adventure Park Webcam",
    "url": "https://www.youtube.com/watch?v=s869fYS-TGY",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 47.5869673,
      "lon": -120.6764195
    }
  },
  {
    "id": "custom-leavenworth-rhein-haus",
    "location": "Leavenworth Rhein Haus Webcam",
    "url": "https://www.youtube.com/watch?v=yHH8EWIR01Y",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 47.595242,
      "lon": -120.6628148
    }
  },
  {
    "id": "custom-leavenworth-mountain-modern",
    "location": "Leavenworth Mountain Modern Webcam",
    "url": "https://www.youtube.com/watch?v=NdW8Mh0lmOo",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 47.5953629,
      "lon": -120.6615442
    }
  },
  {
    "id": "custom-leavenworth-downtown",
    "location": "Leavenworth Downtown Webcam",
    "url": "https://www.youtube.com/watch?v=XjhxRZEm638",
    "source": "CUSTOM",
    "streamType": "youtube",
    "coordinates": {
      "lat": 47.5955958,
      "lon": -120.6619543
    }
  },
  {
    "id": "custom-westport-viewing-tower-ptz",
    "location": "Westport Viewing Tower PTZ",
    "url": "https://c.themediacdn.com/embed/media/WFsdJr/1MA8ku9sO6U/ShdKpisATtu_5",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 46.9115238,
      "lon": -124.117476
    }
  },
  {
    "id": "custom-duwamish-waterway-west-seattle-bridge",
    "location": "Duwamish Waterway at West Seattle Bridge",
    "url": "https://wsrv.nl/?url=162.191.11.144:8000/-wvhttp-01-/GetOneShot%3Fimage_size%3D640x480%26frame_count%3D1",
    "source": "CUSTOM",
    "streamType": "image",
    "refreshMs": 60000,
    "coordinates": {
      "lat": 47.56728315356971,
      "lon": -122.35027127861214
    }
  },
  {
    "id": "custom-lake-washington-ship-canal",
    "location": "Lake Washington Ship Canal",
    "url": "https://video.nest.com/embedded/live/L4kStBoMFQ?autoplay=1",
    "source": "CUSTOM",
    "streamType": "iframe",
    "coordinates": {
      "lat": 47.651242060606904,
      "lon": -122.3237844847679
    }
  }
];

let cameras = {};

	let openStreams = [];
	let cameraMarkers = {};
	let cameraGroupsByCoordinate = {};
	let openUnitIds = [];
	let streamCleanups = {};
	let draggedVideoCard = null;
	const cameraMarkerDefaultColor = '#438cc1';
	const cameraMarkerSelectedColor = '#1f9d55';
	const cameraMarkerErrorColor = '#d33f49';
	const cameraMarkerDesktopRadius = 5;
	const cameraMarkerDesktopGroupRadius = 7;
	const cameraMarkerMobileRadius = 11;
	const cameraMarkerMobileGroupRadius = 13;
	const unavailableCameraMarkerDesktopRadius = 4;
	const unavailableCameraMarkerMobileRadius = 7;
	const streamRetryMs = 60 * 1000;
	const savedCameraOrderCookie = 'seattleTrafficCamOpenIds';
	const savedMapHeightCookie = 'seattleTrafficCamMapHeight';
	const savedCameraOrderCookieMaxAge = 60 * 60 * 24 * 180;

	let mapOpen = true;
	const emptyMapHeightPercent = 84;
	const oneRowMapHeightPercent = 72;
	const minMapHeightPercent = 50;
	const maxMapHeightPercent = 86;
	let mapHeightPercent = emptyMapHeightPercent;
	let mapHeightUserOverride = false;
	let autoMapHeightFrame = null;
	let testsSkipped = false;
	let fullyLoaded = false;

	let warningMessage = "";

	function isCoarsePointerDevice() {
		return typeof window !== 'undefined'
			&& typeof window.matchMedia === 'function'
			&& window.matchMedia('(pointer: coarse)').matches;
	}

	function cameraMarkerRadiusForGroup(groupSize) {
		if (isCoarsePointerDevice()) {
			return groupSize > 1 ? cameraMarkerMobileGroupRadius : cameraMarkerMobileRadius;
		}

		return groupSize > 1 ? cameraMarkerDesktopGroupRadius : cameraMarkerDesktopRadius;
	}

	function unavailableCameraMarkerRadius() {
		return isCoarsePointerDevice() ? unavailableCameraMarkerMobileRadius : unavailableCameraMarkerDesktopRadius;
	}

	function cameraMarkerDefaultWeight() {
		return isCoarsePointerDevice() ? 2 : 1;
	}

	function cameraMarkerActiveWeight() {
		return isCoarsePointerDevice() ? 3 : 2;
	}

	// Set up search result marker
	let searchResultMarker = L.circleMarker([0, 0], {
		radius: 8,
		fillColor: '#c14343',
		fillOpacity: 1,
		color: '#ffffff',
		weight: 2
	});
	searchResultMarker.bindTooltip("Click to dismiss");
	searchResultMarker.on('click', () => {
		searchResultMarker.removeFrom(map);
	});

	// Returns the associated HTML for building a camera stream card template
	// (cursed)
	function makeTemplateHTML(url, name){
		let streamHeader = `<div class="d-flex justify-content-between px-2 py-1 user-select-none stream-header"><div>${name}</div><div><button type="button" class="btn btn-outline-danger btn-sm p-0 px-1" style="font-weight:900;">X</div></div>`

		if (url.endsWith('jpg')) {
			return `<div class="card video-card mb-2" style="width: 25%;">${streamHeader}<img data-id="${url}" class="image-stream img-fluid"></div>`;
		} else {
			return `<div class="card video-card mb-2" style="width: 25%;">${streamHeader}<video muted autoplay controls data-id="${url}"></video></div>`;
		}
	}

function isImageUrl(url) {
		return /\.(?:jpe?g|png|webp)(?:[?#]|$)/i.test(url);
	}

	function isTideworksCameraUrl(url) {
		try {
			return new URL(url).hostname === "terminalcamera.tideworks.com";
		} catch (error) {
			return false;
		}
	}

	function normalizedMinuteNonce(date = new Date()) {
		const pad = (value) => String(value).padStart(2, "0");
		return [
			date.getUTCFullYear(),
			pad(date.getUTCMonth() + 1),
			pad(date.getUTCDate()),
			pad(date.getUTCHours()),
			pad(date.getUTCMinutes())
		].join("");
	}

	function tideworksProxyUrl(url) {
		const source = new URL(url);
		source.search = "";
		source.searchParams.set("_", normalizedMinuteNonce());
		return "https://wsrv.nl/?url=" + source.origin + source.pathname + encodeURIComponent(source.search);
	}

	function imageRefreshUrl(url) {
		if (isTideworksCameraUrl(url)) return tideworksProxyUrl(url);
		const separator = url.indexOf("?") === -1 ? "?" : "&";
		return url + separator + "_=" + Date.now();
	}

function youtubeEmbedUrl(url) {
	const match = String(url).match(/(?:youtube\.com\/watch\?v=|youtube\.com\/live\/|youtube\.com\/embed\/|youtu\.be\/)([A-Za-z0-9_-]+)/);
	return match ? "https://www.youtube-nocookie.com/embed/" + match[1] + "?autoplay=1&mute=1&playsinline=1" : url;
}

	function cameraStreamUrl(camera) {
		if (camera.streamType) return camera.url;
		if (camera.source === "BELLEVUE") return camera.url.replace(/(\r\n|\n|\r)/gm, "");
		return (camera.source == "SDOT" ? `https://61e0c5d388c2e.streamlock.net:443/live/${camera.url.replace('.jpg', '.stream')}/playlist.m3u8` : 'https://images.wsdot.wa.gov/nw/' + camera.url).replace(/(\r\n|\n|\r)/gm, "");
	}

	function bellevueCameraMediaUrl(properties) {
		const id = String(properties.ID || "").trim().toUpperCase();
		if (!id) return "";
		if (properties.Media === "Stream") return `https://trafficcams.bellevuewa.gov:443/traffic-edge/${id}L.stream/playlist.m3u8`;
		const owner = String(properties.OwnedBy || "").trim();
		const prefix = owner === "WSDOT" ? "https://images.wsdot.wa.gov/nw/" : "https://gis.redmond.gov/traffic/tcimages/";
		return `${prefix}${id}.jpg`;
	}

	function bellevueCameraCoordinates(feature) {
		const properties = feature.properties || {};
		if (feature.geometry && Array.isArray(feature.geometry.coordinates)) {
			return {lat: Number(feature.geometry.coordinates[1]), lon: Number(feature.geometry.coordinates[0])};
		}
		return {lat: Number(properties.Latitude), lon: Number(properties.Longitude)};
	}

function shouldProbeCamera(camera) {
		return false;
	}

	function makeCameraTemplateHTML(url, camera){
		const name = escapeHtml(camera.location || "Camera");
		const streamHeader = `<div class="d-flex justify-content-between px-2 py-1 user-select-none stream-header"><div>${name}</div><div><button type="button" class="btn btn-outline-danger btn-sm p-0 px-1" style="font-weight:900;">X</button></div></div>`;

		if (camera.streamType === "youtube" || camera.streamType === "iframe") {
			const source = camera.streamType === "youtube" ? youtubeEmbedUrl(url) : url;
			return `<div class="card video-card mb-2" style="width: 25%;">${streamHeader}<iframe data-id="${escapeHtml(url)}" class="custom-camera-frame" src="${escapeHtml(source)}" title="${name}" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe></div>`;
		}

		if (camera.streamType === "image" || camera.streamType === "mjpeg" || isImageUrl(url)) {
			const refreshMs = camera.streamType === "mjpeg" ? (camera.refreshMs ?? 0) : (camera.refreshMs || 5000);
			return `<div class="card video-card mb-2" style="width: 25%;">${streamHeader}<img data-id="${escapeHtml(url)}" data-refresh-ms="${refreshMs}" class="image-stream img-fluid" alt="${name}"></div>`;
		}

		return `<div class="card video-card mb-2" style="width: 25%;">${streamHeader}<video muted autoplay controls data-id="${escapeHtml(url)}"></video></div>`;
	}

	function escapeHtml(value) {
		return String(value ?? "").replace(/[&<>"']/g, function(character) {
			return {
				"&": "&amp;",
				"<": "&lt;",
				">": "&gt;",
				"\"": "&quot;",
				"'": "&#39;"
			}[character];
		});
	}

function cameraThumbnailUrl(url) {
	const youtubeMatch = String(url).match(/(?:youtube\.com\/watch\?v=|youtube\.com\/live\/|youtube\.com\/embed\/|youtu\.be\/)([A-Za-z0-9_-]+)/);
	if (youtubeMatch) return "https://i.ytimg.com/vi/" + youtubeMatch[1] + "/hqdefault.jpg";
	if (isTideworksCameraUrl(url)) return tideworksProxyUrl(url);
	if (isImageUrl(url)) return url;
		const match = url.match(/\/live\/([^/]+)\.stream\/playlist\.m3u8/i);
		if (!match) return "";
		return "https://www.seattle.gov/trafficcams/images/" + encodeURIComponent(match[1]) + ".jpg";
	}

	function shouldShowCameraThumbnail() {
		return window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches;
	}

	function cameraStreamKind(camera, url) {
		return camera.streamType || (isImageUrl(url) ? "image" : "hls");
	}

	function isExternalLinkCamera(camera) {
		return camera.streamType === "external";
	}

	function openExternalCameraLink(camera) {
		if (!camera.url) return;
		window.open(camera.url, "_blank", "noopener,noreferrer");
	}

	function cameraTooltipEmoji(camera, url) {
		return cameraStreamKind(camera, url) === "image" ? "📷" : "🎥";
	}

	function cameraTooltipLabel(camera, url) {
		const suffix = isExternalLinkCamera(camera) ? " (opens location page)" : "";
		return cameraTooltipEmoji(camera, url) + " " + escapeHtml((camera.location || "Traffic camera") + suffix);
	}

	function cameraTooltipHTML(camera, url) {
		const label = cameraTooltipLabel(camera, url);
		if (!shouldShowCameraThumbnail()) return label;

		const thumbnailUrl = cameraThumbnailUrl(url);
		if (!thumbnailUrl) return label;

		return `<div class="camera-hover-tooltip-content"><img class="camera-hover-tooltip-image" src="${escapeHtml(thumbnailUrl)}" alt="" loading="lazy"><div class="camera-hover-tooltip-label">${label}</div></div>`;
	}

	function cameraCoordinateKey(camera) {
		return `${Number(camera.coordinates.lat).toFixed(7)},${Number(camera.coordinates.lon).toFixed(7)}`;
	}

	function camerasAtSamePoint(camera) {
		return cameraGroupsByCoordinate[cameraCoordinateKey(camera)] || [camera];
	}

	function cameraGroupTooltipHTML(cameraGroup) {
		if (cameraGroup.length === 1) {
			const camera = cameraGroup[0];
			return cameraTooltipHTML(camera, cameraStreamUrl(camera));
		}

		const labels = cameraGroup.map(camera => cameraTooltipLabel(camera, cameraStreamUrl(camera)));
		if (!shouldShowCameraThumbnail()) return labels.join("<br>");

		const items = cameraGroup.map(camera => {
			const url = cameraStreamUrl(camera);
			const thumbnailUrl = cameraThumbnailUrl(url);
			const label = cameraTooltipLabel(camera, url);
			if (!thumbnailUrl) {
				return `<div class="camera-hover-tooltip-item camera-hover-tooltip-item-text"><div class="camera-hover-tooltip-label">${label}</div></div>`;
			}
			return `<div class="camera-hover-tooltip-item"><img class="camera-hover-tooltip-image" src="${escapeHtml(thumbnailUrl)}" alt="" loading="lazy"><div class="camera-hover-tooltip-label">${label}</div></div>`;
		}).join("");

		return `<div class="camera-hover-tooltip-list">${items}</div>`;
	}

function makeMarkerClusterIcon(n) {
		return new L.DivIcon({
			className: "circle-group",
			iconSize: new L.Point(15, 15)
		});
	}

	// Bulk of the code for loading the map & initializing a list of available cameras
	let map;
	let load = (async(container) => {
		// Set up map base layer

		map = L.map(container, {
			center: [47.608, -122.335],
			zoom: 11,
		});
		if (map.createPane && !map.getPane("camera-hover-pane")) {
			const cameraHoverPane = map.createPane("camera-hover-pane");
			cameraHoverPane.style.zIndex = 760;
			cameraHoverPane.style.pointerEvents = "none";
		}
		window.__seattleTrafficCamMap = map;
		window.__seattleTrafficCamLeaflet = L;
        window.dispatchEvent(new CustomEvent("seattle-traffic-map-ready", {
            detail: {
                map,
                Leaflet: L
            }
        }));

        L.tileLayer("https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}", {
            minZoom: 1,
            maxZoom: 19,
            className: "map-tiles",
            attribution:
                'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community',
        }).addTo(map);

		let markers = L.markerClusterGroup({maxClusterRadius: 1, iconCreateFunction: makeMarkerClusterIcon, spiderLegPolylineOptions: {weight: 1, color: '#eee', opacity: 1}});
		map.addLayer(markers);

	// Collect list of cameras

	const datasetResponse = await fetch(datasetRequestUrl);
	const sdotResponse = await fetch(sdotMapApiUrl);
	const bellevueResponse = await fetch(bellevueCameraApiUrl);
	const wsdotKingCountyResponse = await fetch(wsdotKingCountyCameraApiUrl);

	const datasetCameraList = await datasetResponse.json();
	const sdotCameraList = await sdotResponse.json();
	const bellevueCameraList = await bellevueResponse.json();
	const wsdotKingCountyCameraList = await wsdotKingCountyResponse.json();

		// Check SDOT first...
		for (const group of sdotCameraList.Features) {
			let coordinates = {lat: group.PointCoordinate[0], lon: group.PointCoordinate[1]};

			for (const element of group.Cameras) {
				let camera = {};

				camera.id = element.Id;
				camera.location = element.Description;
				camera.url = element.ImageUrl;
				camera.coordinates = coordinates;
				camera.source = element.Type.toUpperCase();

				cameras[element.Id] = camera;
			}
		}

		/// ...Then check the Seattle Open Data source as it contains better location data, and override SDOT data if available
	for (const element of datasetCameraList.features) {
		let camera = {};
		
		camera.id = element.properties.UNITID;
		camera.location = element.properties.LOCATION;
			camera.url = element.properties.NAME;
			camera.coordinates = {lat: element.geometry.coordinates[1], lon: element.geometry.coordinates[0]};
			camera.source = element.properties.OWNERSHIP;

			if (element.properties.UNITID in cameras && cameras[element.properties.UNITID].url == camera.url) {
			cameras[element.properties.UNITID] = camera;
		}
	}

	for (const feature of (bellevueCameraList.features || [])) {
		const properties = feature.properties || {};
		const mediaUrl = bellevueCameraMediaUrl(properties);
		const coordinates = bellevueCameraCoordinates(feature);
		if (!properties.ID || !mediaUrl || !Number.isFinite(coordinates.lat) || !Number.isFinite(coordinates.lon)) continue;

		let camera = {};
		camera.id = "bellevue-" + String(properties.ID).trim().toUpperCase();
		camera.location = "Bellevue - " + (properties.Display_Address || properties.Address || properties.ID);
		camera.url = mediaUrl;
		camera.coordinates = coordinates;
		camera.source = "BELLEVUE";
		if (properties.Media !== "Stream") {
			camera.streamType = "image";
			camera.refreshMs = 60 * 1000;
		}
		cameras[camera.id] = camera;
	}

	for (const element of (wsdotKingCountyCameraList.data || [])) {
		const location = element.CameraLocation || {};
		const latitude = Number(element.DisplayLatitude ?? location.Latitude);
		const longitude = Number(element.DisplayLongitude ?? location.Longitude);
		if (!element.CameraID || !element.ImageURL || !Number.isFinite(latitude) || !Number.isFinite(longitude)) continue;

		let camera = {};
		camera.id = "wsdot-kc-" + String(element.CameraID);
		camera.location = "WSDOT - " + (element.Title || element.Description || location.Description || element.CameraID);
		camera.url = element.ImageURL;
		camera.coordinates = {lat: latitude, lon: longitude};
		camera.source = "WSDOTKC";
		camera.streamType = "image";
		camera.refreshMs = 60 * 1000;
		cameras[camera.id] = camera;
	}

	for (const customCamera of customCameras) {
		cameras[customCamera.id] = Object.assign({}, customCamera);
	}

		// Iterate over each camera and add them to the map

		for (const [_, camera] of Object.entries(cameras)) {
			const url = cameraStreamUrl(camera);
			
			// For SDOT streams only, this will try to make sure the feed actually exists.
			// The force-cache mode may present issues if a camera is only temporarily offline, as the cached result will be used even if stale. Better solution needed at some point.
			const working = !shouldProbeCamera(camera) || await window.__seattleTrafficCamCheckStream(url, camera.source, testsSkipped);
			if (working) {
				const groupKey = cameraCoordinateKey(camera);
				if (!cameraGroupsByCoordinate[groupKey]) cameraGroupsByCoordinate[groupKey] = [];
				cameraGroupsByCoordinate[groupKey].push(camera);

				// Create marker for this camera
				let marker = cameraGroupsByCoordinate[groupKey].length > 1 ? cameraMarkers[cameraGroupsByCoordinate[groupKey][0].id] : null;
				if (!marker) {
					marker = L.circleMarker([camera.coordinates.lat, camera.coordinates.lon], {
						radius: cameraMarkerRadiusForGroup(1),
						fillColor: '#438cc1',
						fillOpacity: 1,
						color: '#eaeaea',
						weight: cameraMarkerDefaultWeight()
					});
					marker.bindTooltip(cameraGroupTooltipHTML(cameraGroupsByCoordinate[groupKey]), {
						className: "camera-hover-tooltip",
						pane: "camera-hover-pane",
						direction: "top",
						offset: [0, -8],
						opacity: 1
						});
				markers.addLayer(marker);
				if (marker.bringToFront) marker.bringToFront();
				}
				cameraMarkers[camera.id] = marker;
				for (const groupCamera of cameraGroupsByCoordinate[groupKey]) {
					const groupMarker = cameraMarkers[groupCamera.id];
					if (!groupMarker) continue;
					if (groupMarker.setRadius) groupMarker.setRadius(cameraMarkerRadiusForGroup(cameraGroupsByCoordinate[groupKey].length));
					groupMarker.bindTooltip(cameraGroupTooltipHTML(cameraGroupsByCoordinate[groupKey]), {
						className: "camera-hover-tooltip",
						pane: "camera-hover-pane",
						direction: "top",
						offset: [0, -8],
						opacity: 1
					});
				}

				// Add or remove camera stream from page on click
				if (!marker._seattleLiveCameraGroupClickBound) {
					marker._seattleLiveCameraGroupClickBound = true;
					marker.on('click', () => {
						if (!fullyLoaded) return;
						toggleCameraGroup(cameraGroupsByCoordinate[groupKey] || [camera]);
					});
				}
			} else {
				let marker = L.circleMarker([camera.coordinates.lat, camera.coordinates.lon], {
					radius: unavailableCameraMarkerRadius(),
					fillColor: '#050505',
					fillOpacity: 0.85,
					color: '#050505',
					opacity: 0.9,
					weight: 1,
					interactive: false
				});
				marker.bindTooltip(camera.location + " (offline)");
				marker.addTo(map);
				if (marker.bringToBack) marker.bringToBack();
				console.log("Camera ", camera.id, " not working, marking unavailable...");
			};
		};

		document.getElementById('skipTests').style.setProperty("visibility", "hidden");

		map.invalidateSize(); // Sometimes neccesary for the map to load properly for some reason?
		openStreams = openStreams;
		fullyLoaded = true;

		// Open saved streams in reverse because each selected camera is prepended.
		for (const id of getSavedOpenUnitIds().reverse()) {
			if (id == '') continue;

			if (id in cameras && id in cameraMarkers) {
				if (isExternalLinkCamera(cameras[id])) continue;
				openCamera(cameras[id], {restore: true});
				cameraMarkers[id].fire('mouseout');
			} else {
				console.warn(`Camera ID ${id} is not available!`);
			}
		};
	});

	// Conduct a search using nominatim for locations given by the user in the search box
	const searchChanged = async(e) => {
		const changeValue = (e.target).value;
		
		if (changeValue === "") return;

		const requestUrl = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(changeValue)}+seattle&format=json&addressdetails=1`;
		const response = await fetch(requestUrl);
		const locationInfo = await response.json();

		if (locationInfo.length < 1 ||
			locationInfo[0].display_name.startsWith("Seattle, King County") ||
			locationInfo[0].address.state != "Washington") return;

		const latitude = locationInfo[0].lat;
		const longitude = locationInfo[0].lon;
		const amenity = locationInfo[0].address.amenity || locationInfo[0].address.tourism;

		// Focus map to search result, move search result marker to location and show it
		map.setView([latitude, longitude], 18);
		searchResultMarker.setLatLng(new L.LatLng(latitude, longitude));
		searchResultMarker.bindTooltip(amenity ? amenity + " (click to dismiss)" : "Click to dismiss");
		searchResultMarker.addTo(map);
	};

	// If user presses the skip button during camera testing, skip the tests
	const skipTestsPressed = async() => {
		testsSkipped = true;
	};

	function setCameraMarkerState(camera, state) {
		camera.markerState = state;
		const cameraGroup = camerasAtSamePoint(camera);
		const markersToUpdate = [...new Set(cameraGroup.map(groupCamera => cameraMarkers[groupCamera.id]).filter(Boolean))];
		if (markersToUpdate.length === 0) return;
		const hasError = cameraGroup.some(groupCamera => groupCamera.markerState === 'error' && openUnitIds.indexOf(groupCamera.id) > -1);
		const hasSelected = cameraGroup.some(groupCamera => openUnitIds.indexOf(groupCamera.id) > -1);

		if (hasError) {
			markersToUpdate.forEach(marker => {
				marker.setStyle({fillColor: cameraMarkerErrorColor});
				marker.setStyle({color: '#ffffff'});
				marker.setStyle({weight: cameraMarkerActiveWeight()});
			});
			return;
		}

		if (hasSelected) {
			markersToUpdate.forEach(marker => {
				marker.setStyle({fillColor: cameraMarkerSelectedColor});
				marker.setStyle({color: '#ffffff'});
				marker.setStyle({weight: cameraMarkerActiveWeight()});
			});
			return;
		}

		markersToUpdate.forEach(marker => {
			marker.setStyle({fillColor: cameraMarkerDefaultColor});
			marker.setStyle({color: '#eaeaea'});
			marker.setStyle({weight: cameraMarkerDefaultWeight()});
		});
	}

	function streamIsOpen(url, camera, main) {
		return main.isConnected && openStreams.indexOf(url) > -1 && openUnitIds.indexOf(camera.id) > -1;
	}

	function cleanupOpenStream(url) {
		if (!streamCleanups[url]) return;
		streamCleanups[url]();
	}

	function cameraIsOpen(camera) {
		if (isExternalLinkCamera(camera)) return false;
		const url = cameraStreamUrl(camera);
		return openStreams.indexOf(url) > -1 && openUnitIds.indexOf(camera.id) > -1;
	}

	function streamElementForUrl(url) {
		return Array.from(document.querySelectorAll('#video-container [data-id]')).find(element => element.dataset.id === url);
	}

	function closeCamera(camera) {
		const url = cameraStreamUrl(camera);
		openStreams = openStreams.filter(item => item !== url);
		openUnitIds = openUnitIds.filter(item => item !== camera.id);
		cleanupOpenStream(url);
		const streamElement = streamElementForUrl(url);
		const card = streamElement ? streamElement.closest('.video-card') : null;
		if (card) card.remove();
		setCameraMarkerState(camera, 'default');
		scheduleAutoMapHeight({force: openUnitIds.length === 0});
	}

	function openCamera(camera, options = {}) {
		if (isExternalLinkCamera(camera)) {
			if (!options.restore) openExternalCameraLink(camera);
			return;
		}
		if (cameraIsOpen(camera)) return;
		const url = cameraStreamUrl(camera);
		openUnitIds.unshift(camera.id);
		openStreams.unshift(url);
		openStreams = openStreams;
		setCameraMarkerState(camera, 'selected');
		addStream(url, camera);
		scheduleAutoMapHeight();
	}

	function toggleCameraGroup(cameraGroup) {
		if (cameraGroup.every(cameraIsOpen)) {
			cameraGroup.forEach(closeCamera);
		} else {
			[...cameraGroup].reverse().forEach(openCamera);
		}
		if (fullyLoaded) saveOpenCameraOrder();
	}

	function hlsNetworkStatus(errorData) {
		return errorData && errorData.response && Number(errorData.response.code);
	}

	function shouldMarkStreamError(errorData) {
		if (!errorData || errorData.type !== Hls.ErrorTypes.NETWORK_ERROR) return false;
		const status = hlsNetworkStatus(errorData);
		return !status || status >= 400;
	}

	// Uses the given url to create a new HLS stream (or image) and place it in the video grid container
	function addStream(url, camera){
		var container = document.getElementById('video-container');
		var template = document.createElement('template');
		template.innerHTML = makeCameraTemplateHTML(url, camera).trim();

		var clone = template.content.cloneNode(true);
		container.insertBefore(clone, container.firstChild);
		var video = container.firstElementChild.querySelector('[data-id]');
		var main = video.parentElement;
		const streamKind = camera.streamType || (isImageUrl(url) ? "image" : "hls");
		main.dataset.unitId = camera.id;
		main.dataset.streamUrl = url;
		main.setAttribute('draggable', 'true');
		var header = main.querySelector('.stream-header');
		var closeButton = header.querySelectorAll('div')[1].querySelector('button');

		var hls = null;
		var streamRetryTimer = null;

		function stopStreamRetry() {
			if (!streamRetryTimer) return;
			clearInterval(streamRetryTimer);
			streamRetryTimer = null;
		}

		function cleanupStream() {
			stopStreamRetry();
			if (hls) {
				hls.destroy();
				hls = null;
			}
			delete streamCleanups[url];
		}

		streamCleanups[url] = cleanupStream;

		function markStreamHealthy() {
			if (!streamIsOpen(url, camera, main)) return;
			setCameraMarkerState(camera, 'selected');
			stopStreamRetry();
		}

		function markStreamError() {
			if (!streamIsOpen(url, camera, main)) return;
			setCameraMarkerState(camera, 'error');
			if (streamRetryTimer) return;
			streamRetryTimer = setInterval(function() {
				if (!streamIsOpen(url, camera, main)) {
					cleanupStream();
					return;
				}
				if (streamKind === "image" || streamKind === "mjpeg") {
					updateImageStream(video, true);
					return;
				}
				if (streamKind === "hls") startHlsStream();
			}, streamRetryMs);
		}

		function startHlsStream() {
			if (!streamIsOpen(url, camera, main)) return;
			if (hls) hls.destroy();
			hls = new Hls();
			hls.on(Hls.Events.MANIFEST_PARSED, markStreamHealthy);
			hls.on(Hls.Events.LEVEL_LOADED, markStreamHealthy);
			hls.on(Hls.Events.FRAG_LOADED, markStreamHealthy);
			hls.on(Hls.Events.ERROR, function(event, errorData) {
				if (shouldMarkStreamError(errorData)) markStreamError();
			});
			hls.loadSource(url);
			hls.attachMedia(video);
		}

		if (streamKind === "image" || streamKind === "mjpeg") {
			video.addEventListener('load', markStreamHealthy);
			video.addEventListener('error', markStreamError);
			updateImageStream(video, true);
		} else if (streamKind === "iframe" || streamKind === "youtube") {
			markStreamHealthy();
		} else {
			startHlsStream();
		}

		video.parentElement.style.setProperty("width", document.getElementById('widthSlider').value + "%");
		header.style.setProperty('display', 'none', 'important');

		main.addEventListener('mouseenter', function() {
			header.style.setProperty('display', 'flex', 'important');
		});

		main.addEventListener('mouseleave', function() {
			header.style.setProperty('display', 'none', 'important');
		});

		closeButton.addEventListener('click', function() {
			cleanupStream();
			closeCamera(camera);
			saveOpenCameraOrder();
		});
	}

	// Updates an existing image camera (WSDOT) by changing the query string to include the current timestamp
	function updateImageStream(video, force = false){
		const refreshAttribute = video.dataset.refreshMs;
		const refreshMs = refreshAttribute === "0" ? 0 : Number(refreshAttribute || 5000);
		if (!force && refreshMs <= 0) return;
		const now = Date.now();
		const lastRefresh = Number(video.dataset.lastRefresh || 0);
		if (!force && lastRefresh && now - lastRefresh < refreshMs) return;
		video.dataset.lastRefresh = String(now);
		video.src = imageRefreshUrl(video.dataset.id);
	}

	function trafficCookieSuffix(maxAge) {
		const secure = window.location.protocol === "https:" ? "; Secure" : "";
		return "; Path=/live; Max-Age=" + maxAge + "; SameSite=Lax" + secure;
	}

	function getTrafficCookie(name) {
		const cookie = document.cookie.split("; ").find(function (item) {
			return item.indexOf(name + "=") === 0;
		});
		if (!cookie) return "";
		return decodeURIComponent(cookie.slice(name.length + 1));
	}

	function setTrafficCookie(name, value, maxAge) {
		document.cookie = name + "=" + encodeURIComponent(value) + trafficCookieSuffix(maxAge);
	}

	function saveMapHeight() {
		const roundedHeight = Math.round(mapHeightPercent * 10) / 10;
		setTrafficCookie(savedMapHeightCookie, String(roundedHeight), savedCameraOrderCookieMaxAge);
	}

	function getSavedMapHeight() {
		const savedValue = Number(getTrafficCookie(savedMapHeightCookie));
		return Number.isFinite(savedValue) ? clampMapHeight(savedValue) : null;
	}

	function saveOpenCameraOrder() {
		const order = openUnitIds.join();
		window.location.hash = order ? "#" + order : "";
		const secure = window.location.protocol === "https:" ? "; Secure" : "";
		const maxAge = order ? savedCameraOrderCookieMaxAge : 0;
		document.cookie = savedCameraOrderCookie + "=" + encodeURIComponent(order) + "; Path=/live; Max-Age=" + maxAge + "; SameSite=Lax" + secure;
	}

	function getSavedOpenUnitIds() {
		const hashIds = window.location.hash.replace("#", "").split(",").filter(Boolean);
		if (hashIds.length > 0) return hashIds;

		const cookie = document.cookie.split("; ").find(function (item) {
			return item.indexOf(savedCameraOrderCookie + "=") === 0;
		});
		if (!cookie) return [];

		const value = cookie.slice(savedCameraOrderCookie.length + 1);
		return decodeURIComponent(value).split(",").filter(Boolean);
	}

	function syncOpenOrderFromCards() {
		const cards = Array.from(document.querySelectorAll('#video-container .video-card'));
		openUnitIds = cards.map(function (card) {
			return card.dataset.unitId;
		}).filter(Boolean);
		openStreams = cards.map(function (card) {
			return card.dataset.streamUrl;
		}).filter(Boolean);
		saveOpenCameraOrder();
	}

	function videoCardFromEvent(event) {
		const container = document.getElementById('video-container');
		const target = event.target && event.target.closest ? event.target.closest('.video-card') : null;
		if (!container || !target || !container.contains(target)) return null;
		return target;
	}

	function videoDragStart(event) {
		if (event.target && event.target.closest && event.target.closest('button, input, select, textarea, a')) return;
		const card = videoCardFromEvent(event);
		if (!card) return;
		draggedVideoCard = card;
		card.classList.add('is-dragging');
		if (event.dataTransfer) {
			event.dataTransfer.effectAllowed = 'move';
			event.dataTransfer.setData('text/plain', card.dataset.unitId || '');
		}
	}

	function videoDragOver(event) {
		if (!draggedVideoCard) return;
		const container = document.getElementById('video-container');
		const target = videoCardFromEvent(event);
		if (!container || !target || target === draggedVideoCard) return;

		event.preventDefault();
		if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';

		const rect = target.getBoundingClientRect();
		const sameRow = event.clientY >= rect.top && event.clientY <= rect.bottom;
		const insertBeforeTarget = sameRow
			? event.clientX < rect.left + (rect.width / 2)
			: event.clientY < rect.top + (rect.height / 2);
		container.insertBefore(draggedVideoCard, insertBeforeTarget ? target : target.nextSibling);
	}

	function finishVideoDrag() {
		if (!draggedVideoCard) return;
		draggedVideoCard.classList.remove('is-dragging');
		draggedVideoCard = null;
		syncOpenOrderFromCards();
	}

	function videoDrop(event) {
		if (!draggedVideoCard) return;
		event.preventDefault();
		finishVideoDrag();
	}

	function videoDragEnd() {
		finishVideoDrag();
	}

	function clampMapHeight(percent) {
		return Math.min(maxMapHeightPercent, Math.max(minMapHeightPercent, percent));
	}

	function invalidateMapSize() {
		if (!map || !mapOpen) return;
		requestAnimationFrame(function() {
			map.invalidateSize();
		});
	}

	function setMapHeight(percent) {
		mapHeightPercent = clampMapHeight(percent);
		document.documentElement.style.setProperty('--traffic-map-height', mapHeightPercent + '%');
		invalidateMapSize();
	}

	function cameraRowMetrics() {
		const cards = Array.from(document.querySelectorAll('#video-container .video-card'));
		const rows = new Map();

		for (const card of cards) {
			const rowTop = Math.round(card.offsetTop);
			const rowHeight = card.getBoundingClientRect().height;
			rows.set(rowTop, Math.max(rows.get(rowTop) || 0, rowHeight));
		}

		return {
			cardCount: cards.length,
			rowCount: rows.size,
			rowHeight: Array.from(rows.values()).reduce((total, height) => total + height, 0)
		};
	}

	function autoMapHeightTarget() {
		const metrics = cameraRowMetrics();
		if (metrics.cardCount === 0) return emptyMapHeightPercent;
		if (metrics.rowCount <= 1) return oneRowMapHeightPercent;

		const controlsHeight = 60;
		const dividerHeight = 10;
		const rowGapHeight = 8 * Math.max(0, metrics.rowCount - 1);
		const videoPadding = 16;
		const neededVideoHeight = metrics.rowHeight + rowGapHeight + videoPadding;
		const availableMapHeight = window.innerHeight - controlsHeight - dividerHeight - neededVideoHeight;
		const measuredTarget = (availableMapHeight / window.innerHeight) * 100;

		if (!Number.isFinite(measuredTarget)) {
			return Math.max(minMapHeightPercent, oneRowMapHeightPercent - ((metrics.rowCount - 1) * 12));
		}

		return Math.min(oneRowMapHeightPercent, Math.max(minMapHeightPercent, measuredTarget));
	}

	function scheduleAutoMapHeight(options = {}) {
		if (autoMapHeightFrame) cancelAnimationFrame(autoMapHeightFrame);
		autoMapHeightFrame = requestAnimationFrame(function() {
			autoMapHeightFrame = null;
			if (!mapOpen) return;
			if (mapHeightUserOverride && !options.force) return;
			setMapHeight(autoMapHeightTarget());
		});
	}

	function updateMapLayout() {
		let divider = document.getElementById('mapResizeDivider');
		document.documentElement.style.setProperty('--traffic-map-height', mapOpen ? mapHeightPercent + '%' : '0%');
		document.documentElement.style.setProperty('--traffic-divider-height', mapOpen ? '10px' : '0px');
		if (divider) divider.style.setProperty('display', mapOpen ? 'block' : 'none');
		invalidateMapSize();
	}

	function setMapHeightFromPointer(clientY) {
		const divider = document.getElementById('mapResizeDivider');
		const dividerHeight = divider ? divider.offsetHeight : 10;
		const mapPixels = window.innerHeight - clientY - (dividerHeight / 2);
		setMapHeight((mapPixels / window.innerHeight) * 100);
	}

	function mapResizePointerDown(event) {
		if (!mapOpen) return;
		const divider = event.currentTarget;
		event.preventDefault();
		divider.classList.add('is-dragging');
		document.body.classList.add('is-resizing-traffic-map');
		if (divider.setPointerCapture) divider.setPointerCapture(event.pointerId);

		const move = function(moveEvent) {
			setMapHeightFromPointer(moveEvent.clientY);
		};
		const stop = function(stopEvent) {
			document.removeEventListener('pointermove', move);
			document.removeEventListener('pointerup', stop);
			document.removeEventListener('pointercancel', stop);
			divider.classList.remove('is-dragging');
			document.body.classList.remove('is-resizing-traffic-map');
			if (divider.releasePointerCapture && stopEvent && Number.isInteger(stopEvent.pointerId)) {
				divider.releasePointerCapture(stopEvent.pointerId);
			}
			invalidateMapSize();
			mapHeightUserOverride = true;
			saveMapHeight();
		};

		document.addEventListener('pointermove', move);
		document.addEventListener('pointerup', stop, { once: true });
		document.addEventListener('pointercancel', stop, { once: true });
		setMapHeightFromPointer(event.clientY);
	}

	// Show/hide map window
	function mapButton(){
		let button = document.getElementById('mapButton');
		mapOpen = !mapOpen;

		button.className = "btn me-2 btn-" + (mapOpen ? "primary" : "secondary");
		updateMapLayout();
		if (mapOpen) scheduleAutoMapHeight({force: openUnitIds.length === 0});

		var url = new URL(window.location.href);
		if (mapOpen) {
			url.searchParams.delete('map');
		} else {
			url.searchParams.set('map', false);
		};
		window.history.replaceState(null, null, url.toString());
	}

	// Clear all currently open streams
	function clearAllButton(){
		const streamsToClear = [...openStreams];
		streamsToClear.forEach(cleanupOpenStream);
		openStreams = [];
		openUnitIds = [];

		var videos = document.getElementsByClassName('video-card');

		Array.from(videos).forEach(function(video){
			video.remove();
		});

	for (const [_, marker] of Object.entries(cameraMarkers)) {
		marker.setStyle({fillColor: cameraMarkerDefaultColor});
		marker.setStyle({color: '#eaeaea'});
		marker.setStyle({weight: cameraMarkerDefaultWeight()});
	};

		saveOpenCameraOrder();
		scheduleAutoMapHeight({force: true});
	}

	// Adjust the width of all video streams (based on percentage of window size from 0 to 100)
	function widthUpdate(){
		var slider = document.getElementById('widthSlider');
		var videos = document.getElementsByClassName('video-card');

		Array.from(videos).forEach(function(video){
			video.style.setProperty("width", slider.value + "%");
		});
		scheduleAutoMapHeight();

		var url = new URL(window.location.href);
		url.searchParams.set('videoWidth', slider.value);
		window.history.replaceState(null, null, url.toString());
	}

	// Play all video streams and adjust their currentTime to 10 seconds less than their duration (SDOT streams update every 10 seconds)
	function playAllButton(){
		for (let video of document.querySelectorAll("video")) {
			video.play();
			video.currentTime = video.duration - 10;
		};
	}

	// Initial startup tasks (ran before the map and camera list are fully loaded)
	onMount(async () => {
		var search = document.getElementById('search');
		var slider = document.getElementById('widthSlider');
		var videoContainer = document.getElementById('video-container');

		search.addEventListener('submit', e => {
			e.preventDefault();
		});
		videoContainer.addEventListener('dragstart', videoDragStart);
		videoContainer.addEventListener('dragover', videoDragOver);
		videoContainer.addEventListener('drop', videoDrop);
		videoContainer.addEventListener('dragend', videoDragEnd);

		const savedMapHeight = getSavedMapHeight();
		if (savedMapHeight !== null) setMapHeight(savedMapHeight);
		window.addEventListener('resize', function() {
			scheduleAutoMapHeight();
		});
		scheduleAutoMapHeight({force: true});

		// Load existing map visibility and video width parameters from the query string, if available
		var url = new URLSearchParams(window.location.search);

		var mapOpen = url.get('map');
		if (mapOpen === 'false') {
			testsSkipped = true;
			mapButton();
		};

		var videoWidth = url.get('videoWidth');
		if (videoWidth != null) {
			slider.value = videoWidth;
			widthUpdate();
		};
		scheduleAutoMapHeight({force: openUnitIds.length === 0});
	});

	// Update all camera images (WSDOT) every 5 seconds
	setInterval(function(){
		var imageStreams = document.getElementsByClassName('image-stream');
		Array.from(imageStreams).forEach(updateImageStream);
	}, 5000);

</script>

<div class="d-flex justify-content-end p-2" style="height: 60px;">
	<input type="range" min="5" max="100" value="25" id="widthSlider" class="ms-2 me-2" on:input={widthUpdate}>
	<Tooltip target="widthSlider" bottom>Video Width</Tooltip>
	<button type="button" class="btn btn-primary me-2" id="mapButton" on:click={mapButton}><Fa icon={faMapLocation} /></button>
	<Tooltip target="mapButton" bottom>Show/Hide Map</Tooltip>
	<button type="button" class="btn btn-outline-danger me-2" id="clearAllButton" on:click={clearAllButton}><Fa icon={faVideoSlash} /></button>
	<Tooltip target="clearAllButton" bottom>Clear All Streams</Tooltip>
	<button type="button" class="btn btn-outline-success" id="playAllButton" on:click={playAllButton}><Fa icon={faPlay} /></button>
	<Tooltip target="playAllButton" bottom>Play All/Move to Current</Tooltip>
</div>
<div id="contents" class="overflow-auto">
	<Container fluid class="p-0">
		<ul id="video-container" class="d-flex flex-wrap p-0"></ul>
	</Container>
</div>
<div
	id="mapResizeDivider"
	role="separator"
	aria-orientation="horizontal"
	aria-label="Resize map and camera feeds"
	on:pointerdown={mapResizePointerDown}
></div>

<div id="map" class="shadow" use:load>
	<div class="d-flex px-4 py-1" style="position: absolute;z-index: 999">
		<Form inline id="search" class="ps-4 py-2">
			<Input type="text" placeholder="Search location..." on:change={searchChanged} />
			<button class="d-none" id="skipTests" type="button" aria-hidden="true" tabindex="-1" on:click={skipTestsPressed}></button>
		</Form>
		{#if warningMessage.length > 0}
			<button type="button" class="btn btn-danger ms-2 my-2" style="height: 38px;font-size:1.5em;" id="warning" on:click={()=>{warningMessage = ""}}><Fa icon={faWarning} /></button>
			<Tooltip target="warning" bottom>{warningMessage}</Tooltip>
		{/if}
	</div>
</div>

<style>
	:global(:root) {
		--traffic-map-height: 84%;
		--traffic-divider-height: 10px;
	}

    :global(#map) {
        padding: 0;
		height: var(--traffic-map-height) !important;
        min-width: 100%;
        width: 100%;
        display: block;
        z-index: 1;
    }

	:global(#contents) {
		height: calc(100% - 60px - var(--traffic-map-height) - var(--traffic-divider-height));
	}

	:global(#mapResizeDivider) {
		position: relative;
		height: var(--traffic-divider-height);
		min-height: var(--traffic-divider-height);
		background: #0d1e2a;
		border-top: 1px solid #31526b;
		border-bottom: 1px solid #31526b;
		cursor: row-resize;
		touch-action: none;
		user-select: none;
		z-index: 2;
	}

	:global(#mapResizeDivider::before) {
		content: "";
		position: absolute;
		left: 50%;
		top: 50%;
		width: 72px;
		height: 3px;
		border-radius: 999px;
		background: #8fb8d8;
		transform: translate(-50%, -50%);
	}

	:global(#mapResizeDivider:hover),
	:global(#mapResizeDivider.is-dragging) {
		background: #123047;
		border-color: #6ea8cf;
	}

	:global(#mapResizeDivider:hover::before),
	:global(#mapResizeDivider.is-dragging::before) {
		background: #d8eefc;
	}

	:global(body.is-resizing-traffic-map) {
		cursor: row-resize;
		user-select: none;
	}

	:global(.circle-group) {
		background-color: #2f5899;
		border: 1px solid #eaeaea;
		border-radius:50%;
		-moz-border-radius:50%;
	}

	:global(.flex-grow) {
		height: 100%;
	}

	:global(video) {
		width: 100% !important;
		height: 100% !important;
	}

	:global(.video-card) {
		background: black !important;
	}

	:global(.form-control) {
		color: rgb(232, 230, 227) !important;
	}

	:global(.leaflet-control-attribution) {
		background-color: rgba(24, 26, 27, 0.7) !important;
		color: rgb(200, 195, 188) !important;
	}

	:global(.leaflet-bar a) {
		background-color: rgba(24, 26, 27) !important;
		color: rgb(232, 230, 227) !important;
	}

	:global(.stream-header) {
		position:absolute;
		left:0;
		right:0;
		background: rgba(0,0,0,0.8);
		z-index: 99;
	}

	:root {
		--map-tiles-filter: brightness(0.6) invert(1) contrast(3) hue-rotate(200deg) saturate(0.3) brightness(0.7);
	}

	@media (prefers-color-scheme: dark) {
		:global(.map-tiles) {
			filter:var(--map-tiles-filter, none);
		}
	}

	:global(.leaflet-interactive) {
		-webkit-animation: fade-in 1s;
		animation: fade-in 1s;
	}

	@keyframes fade-in {
		from { opacity: 0; }
		to   { opacity: 1; }
	}

	@-webkit-keyframes fade-in {
		from { opacity: 0; }
		to   { opacity: 1; }
	}
</style>
